




























import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Notifications from '@/store/modules/notifications';
import store from '@/store/store';
import Auth from '@/store/modules/auth';
import TranscriptionNotification from './notification/TranscriptionNotification.vue';
import LikeNotification from './notification/LikeNotification.vue';
import LevelUpNotification from './notification/LevelUpNotification.vue';
const notificationsModule = getModule(Notifications, store);
const authModule = getModule(Auth, store);

@Component({
  components: {
    TranscriptionNotification,
    LikeNotification,
    LevelUpNotification,
  },
})
export default class NotificationMenu extends Vue {
  show = false;

  get currentUser() {
    return authModule.user;
  }

  get uncheckedCount() {
    return notificationsModule.unchecked.length;
  }

  get list() {
    return notificationsModule.list;
  }

  created() {
    if (authModule.user) notificationsModule.bind({ uid: authModule.user.uid });
  }

  @Watch('show')
  checkNotifications() {
    if (this.show) notificationsModule.checkAll();
  }
}
